import { useMutation } from "@apollo/client";
import { updateEngagementStatus } from "../graphql/mutations/updateEngagementStatus";

export const useEngagementActions = ({
  setIsLoading,
  setToastData,
  handleModalClose,
  refetch,
  programId,
  globalState,
}) => {
  const [updateEngagementStat] = useMutation(updateEngagementStatus);

  const showErrorToast = () => {
    setToastData([
      {
        type: "error",
        text: "Error updating engagement status",
      },
    ]);
  };

  const handleEngagementAction = async (action, engagementItem, data) => {
    try {
      const status = action === "approve" ? "APPROVED" : "REJECTED";
      const engagementId = engagementItem?.id;
      setIsLoading(true);

      const result = await updateEngagementStat({
        variables: {
          id: engagementId,
          programId: programId,
          adminId: globalState?.adminDetails?.gpid,
          reason: data.reason,
          points: data.points,
          status,
        },
      });

      setIsLoading(false);

      if (result?.data?.updateEngagementStatus) {
        const updatedEngagement = result.data.updateEngagementStatus;
        const actionText = action === "approve" ? "approved" : "rejected";
        setToastData([
          {
            type: "success",
            text: `${updatedEngagement?.engagementType} ${actionText} successfully`,
          },
        ]);
        handleModalClose();
        refetch();
        return;
      }

      showErrorToast();
    } catch {
      setIsLoading(false);
      showErrorToast();
    }
  };

  return {
    handleEngagementAction,
    showErrorToast,
  };
};
